import { useMemo } from 'react';

import { DateProps, DateRangeProps, DateRangeVariant, DateVariant } from '@lyearn/ui';

import { DateValue } from '../../../types';
import { TagDatePickerProps } from '../types';

export default function useTagDatePicker(props: TagDatePickerProps) {
  const { onChange, selectedTagValue, includeEndDate, includeTime } = props;

  const dateTagValue = selectedTagValue as DateValue;

  const pickerProps = useMemo(() => {
    if (includeEndDate) {
      return {
        selectedRange: {
          startTime: dateTagValue?.startTime ? new Date(dateTagValue?.startTime) : undefined,
          endTime: dateTagValue?.endTime ? new Date(dateTagValue?.endTime) : undefined,
        },
        onChange: (val: { startTime?: Date; endTime?: Date } | null | undefined) =>
          onChange({
            startTime: val?.startTime ? val?.startTime.toISOString() : undefined,
            endTime: val?.endTime ? val?.endTime.toISOString() : undefined,
          }),
        variant: includeTime ? DateRangeVariant.DateAndTimeRange : DateRangeVariant.DateRange,
      } as DateRangeProps;
    }
    return {
      selectedTime: dateTagValue?.startTime ? new Date(dateTagValue?.startTime) : undefined,
      onChange: (val?: Date | null | undefined) =>
        onChange({
          startTime: val ? val.toISOString() : undefined,
        }),
      variant: includeTime ? DateVariant.DateAndTime : DateVariant.Date,
    } as DateProps;
  }, [dateTagValue, includeEndDate, includeTime, onChange]);

  return {
    pickerProps,
  };
}
